import styled from 'styled-components';
import { Button, mediaQueries, size, colors } from '@everlywell/leaves';

const PromoWrapper = styled.a.attrs((props) => ({
  row: props.row,
  column: props.column,
  span: props.span,
  active: props.active,
}))`
  text-decoration: none;
  display: ${(props) => props.active};
  grid-column: ${(props) => `${props.column} / span ${props.span}`};
  grid-row: ${(props) => props.row};

  /* Row of 5 cards */
  ${mediaQueries.forBigDesktopUp} {
    /* Want to start on 1st or 4th column for a 2 span promo. TODO: support different spans  */
    grid-column: ${(props) =>
        props.column > 1 ? props.column + 1 : props.column} / span
      ${(props) => props.span};
  }

  /* Rows of 3 cards - always start on 2nd column */
  ${mediaQueries.forTabletHorizontalDown} {
    grid-column: 2 / span ${(props) => props.span};
  }

  /* Rows of 2 cards - prevent promo on 1st row, always start in 1st column */
  ${mediaQueries.forTabletVerticalDown} {
    grid-column: 1 / span ${(props) => props.span};
    grid-row: ${(props) => (props.row > 1 ? props.row : 2)};
  }
`;

const ImageWrapper = styled.div`
  box-shadow: 0 7px 30px -10px #dce4e5;
  border: solid 1px ${colors.teal1};
  border-radius: ${size.xs3}px;

  .gatsby-image-wrapper-constrained {
    display: flex;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: ${size.lg}px;
  text-decoration: none;
  font-size: 20.3px;
  font-family: Nexa;
  font-weight: normal;
  line-height: 1.28;
  letter-spacing: 0.3px;
  color: ${colors.teal6};

  ${mediaQueries.forPhoneOnly} {
    flex-direction: column;
    padding-top: ${size.md}px;
    padding-bottom: 0;
  }
`;

const PromoContent = styled.p`
  ${mediaQueries.forPhoneOnly} {
    padding-bottom: ${size.md}px;
    width: auto;
  }

  ${mediaQueries.forTabletVerticalUp} {
    max-width: 65%;
  }
`;

const PromoButton = styled(Button)`
  height: 50%;
  ${mediaQueries.forPhoneOnly} {
    width: 55%;
  }
`;

export {
  PromoWrapper,
  ImageWrapper,
  ContentWrapper,
  PromoContent,
  PromoButton,
};
